import styles from "./SpotlightRow.module.css"
import GameCard, { CardType } from "@/components/UI/GameCard/GameCard"
import LinkButton from "@/components/UI/Buttons/LinkButton/LinkButton"
import { useTranslations } from "next-intl"
import { Row } from "@/interfaces/rows_types"

export default function SpotlightRow({ row, analyticsPosition }: { row: Row, analyticsPosition?: number }) {
    const t = useTranslations('SpotlightRow')
    
    const viewMoreLink = (() => {
        switch (row.content_type) {
            case 3:
                return '/game-history'
            case 4:
                return '/catalogue?favorites=true'
            case 1:
            case 5:
            case 6:
            case 2:
                if (row.show_more_action === 'search-genre') return `/catalogue?genre=${row.genre?.id ?? ''}`
                if (row.show_more_action === 'special-page') return `/collection/${row.id}`
                return `/collection/${row.id}`
            default:
                return `/collection/${row.id}`
        }
    })()
    return (
        <div className={styles.main}>
            <div className={styles.content}>
                <h2 className={`${styles.title} title2`}>{row.title}</h2>
                <div className={styles.cards}>
                    {row.content.slice(0,5).map((game, i) => {
                        return (
                            <GameCard analyticsIndex={i} analyticsModuleRow={analyticsPosition} analyticsModule="row" analyticsRow={row.id} analyticsRowName={row.title} key={i} game={game} type={CardType.Vertical} mirror={true}/>
                        ) 
                    })}
                </div>
                <p className={styles.description}>{row.spotlight_text}</p>
                <LinkButton className={styles.button} href={viewMoreLink}>{t('viewAll')}</LinkButton>
            </div>
            

        </div>
    )
}